export default __webpack_public_path__ + "static/dipping-e0e21db39d140f160f8e07c6145a2e55.png";